import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { PolicyHolder } from "@/shared/domain";

import { FolderType } from "../../utils";
import FolderItem from "./FolderItem/FolderItem";
import { StyledFolderContainer, StyledFolderHeader } from "./styled";

type FolderPanelProps = {
    policyholders: PolicyHolder[];
    type: FolderType;
    onPolicyholderClick: (id: number) => void;
    dataTestId?: string;
};

const FolderPanel: FC<FolderPanelProps> = ({ policyholders, type, onPolicyholderClick, dataTestId }) => {
    const { t } = useTranslation();

    return (
        <div data-testid={dataTestId}>
            <StyledFolderHeader>
                {type === FolderType.PARTICULAR ? t("MyFiles.General.Particular") : t("MyFiles.General.Company")}
            </StyledFolderHeader>
            <StyledFolderContainer>
                {policyholders.map((policyholder) => (
                    <FolderItem
                        key={`policyholder-${policyholder.policyHolderId}`}
                        policyholder={policyholder}
                        type={type}
                        onPolicyholderClick={() => onPolicyholderClick(policyholder.policyHolderId)}
                    />
                ))}
            </StyledFolderContainer>
        </div>
    );
};

export default FolderPanel;
